module.exports = __webpack_public_path__ + "static/media/engine-fan_grey.6b8d388f.png";